import * as React from "react";
const SVGComponent = (props) => (
    <svg
        width={38}
        height={39}
        viewBox="0 0 38 39"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <circle cx={19} cy={19.1758} r={19} fill="#005586" />
        <path
            d="M17.4688 15.5101L18.7549 14.9715C18.9118 14.9058 19.0883 14.9058 19.2452 14.9715L20.5312 15.5101V10.5684H17.4688V15.5101Z"
            fill="white"
        />
        <path
            d="M25.7092 17.5909C26.3672 17.5909 27.0034 17.6858 27.6053 17.862V12.1297C27.6053 11.2698 26.9058 10.5703 26.0459 10.5703H21.7985V16.4659C21.7985 16.6783 21.6923 16.8766 21.5154 16.9942C21.4097 17.0646 21.2871 17.1004 21.1637 17.1004C21.0807 17.1004 20.9975 17.0843 20.9186 17.0512L18.9979 16.2471L17.0771 17.0512C16.8814 17.1333 16.6574 17.1119 16.4805 16.9942C16.3036 16.8766 16.1974 16.6783 16.1974 16.4659V10.5703H11.95C11.0901 10.5703 10.3906 11.2698 10.3906 12.1297V26.2256C10.3906 27.0855 11.0901 27.785 11.95 27.785H19.8879C19.2918 26.7779 18.9488 25.604 18.9488 24.3514C18.9488 20.6236 21.9815 17.5909 25.7092 17.5909Z"
            fill="white"
        />
        <path
            d="M16.4844 17.5449H27.6084V26.2834C27.6084 27.1119 26.9368 27.7834 26.1084 27.7834H16.4844V17.5449Z"
            fill="white"
        />
    </svg>
);
export default SVGComponent;
